import React from 'react'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'

export const articles = [
  {
    articleId: '18727947',
    abo: true,
    overline: 'Corona-Dashboard',
    title: 'Die neusten Zahlen zur Corona-Pandemie',
    lead: '',
    class: 'switzerland',
    icon: (
      <>
        <img
          src={require('../../images/schweiz.svg')}
          className='icon schweiz'
          alt='icon schweiz karte'
        />
        {/* <i className='icon syringe' /> */}
      </>
    )
  },
  {
    articleId: '208920009412',
    abo: true,
    overline: 'Kantonsübersicht',
    title: 'Zürcher Zahlen zur Corona-Pandemie',
    lead: '',
    class: 'zuerich',
    icon: (
      <>
        <img
          src={require('../../images/zh-wappen.svg')}
          className='icon zhWappen'
          alt='icon zh-wappen'
        />
      </>
    )
  },
  {
    articleId: '689821411167',
    abo: true,
    overline: 'Spitalbetten',
    title: 'So ausgelastet sind die Spitäler in den Kantonen',
    lead: '',
    class: 'hospitalisation',
    icon: (
      <>
        <img
          src={require('../../images/spital.svg')}
          className='icon spital'
          alt='icon spital'
        />
        {/* <i className='icon hospital outline' /> */}
      </>
    )
  },
  {
    articleId: '378726160093',
    abo: true,
    overline: 'Ländervergleich',
    title: 'Wo die Corona-Fallzahlen am höchsten sind',
    lead: '',
    class: 'quarantine',
    icon: (
      <>
        <img
          src={require('../../images/hand.svg')}
          className='icon quarantaene'
          alt='icon hand stop'
        />
        {/* <i className='icon map signs' /> */}
      </>
    )
  }
]
